import React from "react";
import SessionModel from "../../api/models/SessionModel";
import classNames from "classnames";
type TimeRemainingLabelProps = {
  children: React.ReactNode;
  session: SessionModel;
  onClick?: () => void;
  className?: string;
};
export default function TimeRemainingLabel({
  session,
  children,
  onClick,
  className,
}: TimeRemainingLabelProps) {
  if (session.isInProgress) {
    return (
      <button
        type="button"
        data-cy="enterSessionButton"
        className={classNames(
          "inline-flex justify-center rounded-md border border-transparent disabled:bg-gray-600 bg-brandblue-600 py-2 px-4 text-white shadow-sm hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2",
          className
        )}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }

  return (
    <div
      data-cy="enterSessionButton"
      onClick={onClick}
      className={classNames(
        "w-full   flex  align-middle p-2",
        className ? className : "justify-center bg-gray-100 text-gray-600"
      )}
    >
      {children}
    </div>
  );
}
